/** 列表页 tab / 搜索条件：离开后再回来时从 sessionStorage 恢复；关闭页面时释放 */

export const PRODUCT_ORDER_LIST_VIEW_STATE_KEY = 'productOrderList_viewState'
export const SERVICE_PACKAGE_ORDER_LIST_VIEW_STATE_KEY = 'servicePackageOrderList_viewState'
export const CANCEL_ORDER_LIST_VIEW_STATE_KEY = 'cancelOrderList_viewState'
export const PRODUCT_LIST_VIEW_STATE_KEY = 'productList_viewState'
export const SERVICE_PACKAGE_LIST_VIEW_STATE_KEY = 'servicePackageList_viewState'
export const WATER_PACKAGE_LIST_VIEW_STATE_KEY = 'waterPackageList_viewState'

export const PRODUCT_ORDER_LIST_TAB_PATH = '/main/order/product/list'
export const SERVICE_PACKAGE_ORDER_LIST_TAB_PATH = '/main/order/service-package/list'
export const CANCEL_ORDER_LIST_TAB_PATH = '/main/order/cancel/list'
export const PRODUCT_LIST_TAB_PATH = '/main/product/list'
export const SERVICE_PACKAGE_LIST_TAB_PATH = '/main/product/service-package/list'
export const WATER_PACKAGE_LIST_TAB_PATH = '/main/product/water-package/list'

const TAB_PATH_TO_VIEW_STATE_KEY = {
  [PRODUCT_ORDER_LIST_TAB_PATH]: PRODUCT_ORDER_LIST_VIEW_STATE_KEY,
  [SERVICE_PACKAGE_ORDER_LIST_TAB_PATH]: SERVICE_PACKAGE_ORDER_LIST_VIEW_STATE_KEY,
  [CANCEL_ORDER_LIST_TAB_PATH]: CANCEL_ORDER_LIST_VIEW_STATE_KEY,
  [PRODUCT_LIST_TAB_PATH]: PRODUCT_LIST_VIEW_STATE_KEY,
  [SERVICE_PACKAGE_LIST_TAB_PATH]: SERVICE_PACKAGE_LIST_VIEW_STATE_KEY,
  [WATER_PACKAGE_LIST_TAB_PATH]: WATER_PACKAGE_LIST_VIEW_STATE_KEY,
}

/** 关闭列表页后禁止再写入，直到该 Tab 再次真正打开 */
const releasedKeys = new Set()

export function saveListViewState(key, state) {
  if (!key || releasedKeys.has(key) || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(key, JSON.stringify(state))
  } catch (e) {
    /* ignore quota / private mode */
  }
}

export function loadListViewState(key) {
  if (!key || releasedKeys.has(key) || typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (e) {
    return null
  }
}

export function clearListViewState(key) {
  if (!key || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.removeItem(key)
  } catch (e) {
    /* ignore */
  }
}

export function markListViewStateReleased(key) {
  if (!key) return
  releasedKeys.add(key)
  clearListViewState(key)
}

export function allowListViewStatePersist(key) {
  if (key) releasedKeys.delete(key)
}

export function clearListViewStateByTabPath(path) {
  const key = TAB_PATH_TO_VIEW_STATE_KEY[path]
  if (key) markListViewStateReleased(key)
}
